:host {
  display: inline;
  /** @prop --spinner-color: Set the path color of the spinner. */
  /** @prop --path: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --spinner-color: var(--path, currentColor);

  /** @prop --spinner-duration: Set the duration of the spinner animation. */
  /** @prop --duration: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --spinner-duration: var(--duration, 2s);

  /** @prop --spinner-animation: Set the animation properties of the spinner. */
  --spinner-animation: rotation var(--spinner-duration) linear infinite;

  /** @prop --animation: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --animation: var(--spinner-animation);

  /** @prop --spinner-start-rotation: Set the starting rotation of the spinner. */
  --spinner-start-rotation: rotate(0deg);

  /** @prop --start-rotation: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --start-rotation: var(--spinner-start-rotation);

  /** @prop --spinner-end-rotation: Set the ending rotation of the spinner. */
  --spinner-end-rotation: rotate(360deg);

  /** @prop --end-rotation: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --end-rotation: var(--spinner-end-rotation);

  stroke: var(--spinner-color);
  //Rotate full icon
  .spinner {
    animation: var(--spinner-animation);
    aspect-ratio: 1/1;
    width: 100%;
    height: 100%;
  }
  .path {
    stroke: var(--spinner-color);
  }

  .path.colors {
    stroke-dashoffset: 0;
    transform-origin: center center;
  }
  .xsmall {
    width: 12px;
  }
  .small {
    width: 16px;
  }
  .medium {
    width: 24px;
  }
  .large {
    width: 36px;
  }
  .xlarge {
    width: 48px;
  }
}

@keyframes rotation {
  0% {
    transform: var(--spinner-start-rotation);
  }
  100% {
    transform: var(--spinner-end-rotation);
  }
}
